import { render, staticRenderFns } from "./tableComs.vue?vue&type=template&id=6804ca39&scoped=true&"
import script from "./tableComs.vue?vue&type=script&lang=js&"
export * from "./tableComs.vue?vue&type=script&lang=js&"
import style0 from "./tableComs.vue?vue&type=style&index=0&lang=css&"
import style1 from "./tableComs.vue?vue&type=style&index=1&id=6804ca39&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6804ca39",
  null
  
)

export default component.exports